import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { TradeOrganizationProvider } from "../../context/TradeOrganizationContext";

export const TradeOrganization = () => {
  return (
    <TradeOrganizationProvider>
      <Overview />
    </TradeOrganizationProvider>
  );
};

export const AddTradeOrganization = () => {
  return (
    <TradeOrganizationProvider>
      <Add />
    </TradeOrganizationProvider>
  );
};

export const EditTradeOrganization = () => {
  return (
    <TradeOrganizationProvider>
      <Edit />
    </TradeOrganizationProvider>
  );
};
